var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","width":"100%","height":"100%","background":"#27ae60"},on:{"click":_vm.startProgram}},[_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("Click để bắt đầu chương trình")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777d7946","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartPage.vue
// module id = null
// module chunks = 